<template>
  <div>
    <vxe-modal
      v-model="dialogVisible"
      :before-hide-method="handleClose"
      width="80%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>题库选题列表</span>
      </template>
      <template #default>
        <div class="single-content-wrapper">
          <el-row class="btn-row">
            <!-- 按钮节点区域-->
            <div class="option">
              <el-button v-show="IsShowConfirm" @click="handleConfirm">
                <span>确认</span>
              </el-button>
              <el-button @click="handleCancel">
                <span>关闭</span>
              </el-button>
            </div>
          </el-row>
          <!-- 表达区域-->
          <div class="switch-display border-all">
            <a-row>
              <a-col :span="6">
                <div class="block">
                  <!-- <div>
                    <el-input
                      class="input"
                      v-model="bankName"
                      placeholder="搜索题库"
                    ></el-input>
                  </div> -->
                  <!-- <div> -->
                    <!-- <el-table
                      :data="QuestionBank"
                      style="width: 100%"
                      border
                      @row-click="rowCilick($event)"
                      :row-style="isRed"
                    >
                      <el-table-column type="index" :index="indexMethod" />
                      <el-table-column prop="name" label="题库名称" />
                    </el-table> -->
                    <vxe-toolbar>
                      <template #buttons>
                        <vxe-input v-model="bankName" type="search" placeholder="搜索题库" @keyup="searchBank"></vxe-input>
                      </template>
                    </vxe-toolbar>
                    <vxe-table
                      :loading="loading"
                      :data="QuestionBankFilter"
                      style="width: 100%"
                      border
                      :row-style="isRed"
                      :highlight-current-row="true"
                      @current-change="handleCurrentChange"
                      highlight-hover-row
                      empty-text="没有更多数据了！"
                      stripe
                      class="mytable-scrollbar"
                      height="388"
                      show-overflow="tooltip"
                    >
                      <vxe-table-column
                        fixed="left"
                        type="seq"
                        width="55"
                        title="序号"
                        align="center"
                      ></vxe-table-column>
                      <vxe-table-column field="name" title="题库名称"/>
                    </vxe-table>
                  <!-- </div> -->
                </div>
              </a-col>
              <a-col :span="18">
                <div class="block block_left">
                  <!-- <div>
                    <el-select
                      class="input"
                      v-model="questionBankList.type"
                      placeholder="选择题型"
                    >
                      <el-option
                        v-for="item in typeListCopy"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code"
                        size="medium"
                      />
                    </el-select>
                    <el-input
                      class="input"
                      v-model="questionBankList.name"
                      placeholder="搜索题目"
                    ></el-input>
                  </div> -->
                  <!-- <div> -->
                    <!-- <el-table
                      :data="SelectedQuestionBank.questionBankLists"
                      style="width: 100%"
                      border
                      @selection-change="handleSelectionChange"
                      ref="multipleTableRef"
                      row-key="id"
                    >
                      <el-table-column type="index" :index="indexMethod" />
                      <el-table-column type="selection" width="55" :reserve-selection="true"/>
                      <el-table-column prop="questionsList" label="题目" width="480" />
                      <el-table-column prop="type" label="题目类型" width="80" :formatter="formatStatus" />
                    </el-table> -->
                    <vxe-toolbar>
                      <template #buttons>
                        <vxe-select v-model="questionBankList.type" placeholder="选择题型" clearable>
                          <vxe-option
                            v-for="item in typeListCopy"
                            :key="item.code"
                            :label="item.name"
                            :value="item.code"
                            size="medium"
                          />
                        </vxe-select>
                        <vxe-input v-model="questionBankList.name" type="search" placeholder="搜索题目"></vxe-input>
                      </template>
                    </vxe-toolbar>
                    <vxe-table
                      :data="QuestionBankListFilter"
                      style="width: 100%"
                      border
                      ref="multipleTableRef"
                      :highlight-current-row="true"
                      highlight-hover-row
                      empty-text="没有更多数据了！"
                      stripe
                      @checkbox-change="handleSelectionChange"
                      @checkbox-all="selectAllChangeEvent"
                      class="mytable-scrollbar"
                      height="388"
                      show-overflow="tooltip"
                    >
                      <vxe-table-column
                        fixed="left"
                        type="checkbox"
                        field="tableCheck"
                        width="40"
                      ></vxe-table-column>
                      <vxe-table-column
                        fixed="left"
                        type="seq"
                        width="55"
                        title="序号"
                        align="center"
                      ></vxe-table-column>
                      <vxe-table-column field="questionsList" title="题目" width="340"/>
                      <vxe-table-column field="type" title="题目类型" width="80" :formatter="formatStatus"/>
                    </vxe-table>
                  <!-- </div> -->
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import {GetQuestionBankData} from "@api/Exam/ApiQuestionBank";
import XEUtils from "xe-utils";

export default {
  name: "QuestionBankList",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
    GUID: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      typeListCopy: [
        { name: "-全部-", code: -1 },
        { name: "单选", code: 0 },
        { name: "多选", code: 1 },
        { name: "问答", code: 2 },
      ],
      SelectData: {},
      IsReadonly: false,
      IsShowConfirm: true,
      IsReadonlyCode: true,
      OpStatus: "Detail",
      questionBankData: [
        {
          id:1,
          name: "Tom",
        },
        {
          id:2,
          name: "Dog",
        },

      ],
      bankName: "",
      questionBankList: {
        type: -1,
        name: "",
      },
      QuestionBank:[],//题库以及题目
      QuestionBankFilter:[],//题库以及题目（页面显示）
      SelectedQuestionBank: {},//选中的题库
      selectionKeys: [],//选中的题目
      questionBankListIds:[],//选中的题目的id
      loading: false
    };
  },
  created() {},
  mounted() {

  },
  methods: {
    checked(){
      let _this = this

      _this.SelectedQuestionBank.questionBankLists.forEach(row => {

          if(_this.selectionKeys.find(x=>x.id==row.id))_this.$refs.multipleTableRef.toggleCheckboxRow(row, true);

      })

    },
    selectAllChangeEvent({ checked, records }) {
      this.handleSelectionChange({ records });
    },
    handleSelectionChange({ records }){ //只要复选框勾选了，就会打印
      let val = records;
      var _this = this
      //_this.SelectedQuestionBank.questionBankLists //选择的题库的所有的题目
      //val 是当前选择的题库中选中的题目
      //debugger
      // 找出需要删除的
      var deleteItems = _this.selectionKeys.filter(s => {
        let item = val.find(x => {
          return x.id == s.id
        })
        let item1 = _this.QuestionBankListFilter.find(x => {
          return x.id == s.id
        })
        return !item && item1
      })
      // 找出需要新增的
      var addItems = val.filter(s => {
        let item = _this.selectionKeys.find(x => {
          return x.id == s.id
        })
        return !item
      })
      if(deleteItems.length > 0) {
        deleteItems.forEach(x => {
          _this.selectionKeys.splice(_this.selectionKeys.indexOf(t=>t.id==x.id),1)
        })
      }
      if(addItems.length > 0) {
        addItems.forEach(x => {
          _this.selectionKeys.push(x)
        })
      }
      console.log('deleteItems',deleteItems)
      console.log('addItems',addItems)
      console.log('_this.selectionKeys',_this.selectionKeys)
      // _this.SelectedQuestionBank.questionBankLists.forEach(x=>{
      //   if(val.find(t=>t.id==x.id)){
      //     //选中
      //     if(!_this.selectionKeys.find(t=>t.id==x.id)){
      //       //不存在
      //       _this.selectionKeys.push(x)
      //     }
      //   }else{
      //     //未选中
      //     if(_this.selectionKeys.find(t=>t.id==x.id)){
      //       //存在
      //       _this.selectionKeys.splice(_this.selectionKeys.indexOf(t=>t.id==x.id),1)
      //     }
      //   }
      // })
      //debugger
      // var a=JSON.stringify(_this.selectionKeys[0])
      // console.log(a)
    },
    handleCurrentChange({ row }) {
      this.rowCilick(row);
    },
    rowCilick(row){

      let _this = this
      if(_this.questionBankListIds && _this.questionBankListIds.length>0)
      {
        row.questionBankLists.forEach(x=>{
          if(_this.questionBankListIds.find(t=>t==x.id) && !_this.selectionKeys.find(t=>t.id==x.id)){
            _this.selectionKeys.push(x)
          }
        })
      }

      _this.SelectedQuestionBank = row
      _this.checked()

    },
    indexMethod(index) {
      return index +1;
    },
    /**
     * type==> Add,Modify,Detail
     */
    loadDataById(id, type,questionBankListIds) {
      if(questionBankListIds)this.questionBankListIds=questionBankListIds
      this.GetDataQuestionBank()
    },
    //获取题库
    GetDataQuestionBank(){
      let _this = this
      this.loading = true;
      GetQuestionBankData().then(res=>{
        _this.loading = false;
        _this.QuestionBank = res
        _this.QuestionBankFilter = res
      }).catch(res=>{
        _this.loading = false;
        this.$message.error(res.message);
      })
    },
    formatStatus: function ({row, column, cellValue}) {
      var statusTxt = '';
      statusTxt = cellValue === 0?"单选":cellValue === 1?"多选":"问答";
      return statusTxt;
    },
    isRed({ row }) {

      if (this.SelectedQuestionBank.id==row.id) {
        return {
          backgroundColor: "#DE6",
          //color: "red",
        };
      }
    },
    handleClose() {
      this.$emit("close-dialog");
    },
    handleCancel() {
      this.$emit("handle-cancel");
    },
    handleConfirm() {
      this.$emit("handle-confirm",this.selectionKeys);
    },
    searchBank() {
      const filterName = XEUtils.toValueString(this.bankName).trim().toLowerCase()
      if (filterName) {
        const filterRE = new RegExp(filterName, 'gi')
        const searchProps = ['name']
        const rest = this.QuestionBank.filter(item => searchProps.some(key => XEUtils.toValueString(item[key]).toLowerCase().indexOf(filterName) > -1))
        this.QuestionBankFilter = rest.map(row => {
          const item = Object.assign({}, row)
          searchProps.forEach(key => {
            item[key] = XEUtils.toValueString(item[key]).replace(filterRE, match => `<span class="keyword-lighten">${match}</span>`)
          })
          return item
        })
      } else {
        this.QuestionBankFilter = this.QuestionBank
      }
    },
  },
  computed:{
    QuestionBankListFilter() {
      const filterName = XEUtils.toValueString(this.questionBankList.name).trim().toLowerCase()
      const filtertype = XEUtils.toValueString(this.questionBankList.type).trim().toLowerCase()
      if (filterName || filtertype != "-1") {
        const filterRE = new RegExp(filterName, 'gi')
        const rest = this.SelectedQuestionBank.questionBankLists.filter(item => {
          let match1 = true;
          let match2 = true;
          if(filterName) {
            match1 = XEUtils.toValueString(item["questionsList"]).toLowerCase().indexOf(filterName) > -1
          }
          if(filtertype != "-1") {
            match2 = item["type"] == filtertype;
          }
          return match1 && match2
        })
        return rest.map(row => {
          const item = Object.assign({}, row)
          if(filterName) {
            item["questionsList"] = XEUtils.toValueString(item["questionsList"]).replace(filterRE, match => `<span class="keyword-lighten">${match}</span>`)
          }
          return item
        })
      } else {
        return this.SelectedQuestionBank.questionBankLists
      }
    }
  }
};
</script>


<style lang="scss" scoped>
.block {
  padding: 0 0 10px 10px;
  // text-align: center;
  border-right: solid 1px var(--el-border-color);
  display: inline-block;
  width: 45%;
  box-sizing: border-box;
  vertical-align: top;
}
.block_left {
  margin-left: 5%;
}
.block .input {
  float: left;
  width: 30%;
}
.formtable {
  padding: 0 20px;
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 5px 0;
}

.Commit {
  padding: 20px 0;
  text-align: center;
}
::v-deep .el-form-item__label {
  width: 80px;
  padding: 0;
  text-align: left;
}
.tyyzm ::v-deep .el-form-item__label {
  width: 120px;
}
.textarea-note {
  font-size: var(--el-form-label-font-size);
  padding: 5px 0;
}
.el-textarea {
  margin: 5px 0;
  width: 100%;
}
.btn-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 5px;
}

.option {
  margin: 0px 0 20px 20px;
  .el-button {
    min-height: 0;
    background: #1c6de4;
    border-radius: 3px;
    font-size: 12px;
    color: #ffffff;
    padding: 12px 20px;
    border: 0;

    .custom-icon {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
}
.single-content-wrapper {
  min-height: 60vh;
  background-color: #fff;
  padding-bottom: 15px;
}
.switch-display {
  position: relative;
}
.border-all {
  border: 1px solid #dcdfe6;
}
/*滚动条整体部分*/
.mytable-scrollbar ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/*滚动条的轨道*/
.mytable-scrollbar ::-webkit-scrollbar-track {
  background-color: #ffffff;
}

/*滚动条里面的小方块，能向上向下移动*/
.mytable-scrollbar ::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
  border-radius: 5px;
  border: 1px solid #f1f1f1;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.mytable-scrollbar ::-webkit-scrollbar-thumb:hover {
  background-color: #a8a8a8;
}

.mytable-scrollbar ::-webkit-scrollbar-thumb:active {
  background-color: #787878;
}

/*边角，即两个滚动条的交汇处*/
.mytable-scrollbar ::-webkit-scrollbar-corner {
  background-color: #ffffff;
}
</style>
